import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import "./recruiterPerformanceReport.css";

const API_URL = process.env.REACT_APP_API_URL || "https://api.transtrackglobal.in";


const RecruiterPerformance = () => {
  const [recruiters, setRecruiters] = useState([]);
  const [misData, setMisData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    year: "",
    month: "",
    recruiter: "",
  });

  /* ---------------- LOAD RECRUITERS ---------------- */
  useEffect(() => {
    const fetchRecruiters = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/recruiterName`);
        setRecruiters(res.data);
      } catch (error) {
        console.error("Failed to load recruiters", error);
      }
    };
    fetchRecruiters();
  }, []);

  const years = ["2025", "2026"];
  const months = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];

  /* ---------------- HANDLERS ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {};
    if (filters.year) payload.year = Number(filters.year);
    if (filters.month) payload.month = Number(filters.month);
    if (filters.recruiter) payload.recruiter = filters.recruiter;

    const res = await axios.post(
      `${API_URL}/api/recruiterPerformanceRpt`,
      payload
    );

    setMisData(res.data.data);
    setLoading(false);
  };

  /* ---------------- EXCEL EXPORT ---------------- */
  const exportToExcel = () => {
    if (!misData) return;

    const exportData = [
      {
        Pipeline: misData.Pipeline ?? 0,
        Shortlisted: misData.Shortlisted ?? 0,
        Offered: misData.Offered ?? 0,
        Joined: misData.Joined ?? 0,
        "Serving NP": misData.ServingNP ?? 0,
        Released: misData.Released ?? 0,
        Absconded: misData.Absconded ?? 0,
        Dropout: misData.Dropout ?? 0,
        "Average Joined%": `${misData.joiningConversionPct ?? 0}%`,
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Recruiter Performance");

    XLSX.writeFile(workbook, "Recruiter_Performance_Report.xlsx");
  };

  /* ---------------- JSX ---------------- */
  return (
    <div className="mis-page">
      {/* HEADER */}
      <div className="mis-header">
        <h3 className="mis-title">Recruiter Performance Report</h3>
        <Link to="/dashboard" className="btn outline-btn">
          <i className="bi bi-arrow-left"></i> Dashboard
        </Link>
      </div>

      {/* FILTER CARD */}
      <form className="mis-card" onSubmit={handleSubmit}>
        <div className="mis-grid">
          <div className="input-3d">
            <label>Year</label>
            <select name="year" value={filters.year} onChange={handleChange}>
              <option value="">Select</option>
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>

          <div className="input-3d">
            <label>Month</label>
            <select name="month" value={filters.month} onChange={handleChange}>
              <option value="">Select</option>
              {months.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </select>
          </div>

          <div className="input-3d">
            <label>Recruiter</label>
            <select
              name="recruiter"
              value={filters.recruiter}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {recruiters.map((rec) => (
                <option key={rec.recruiterName} value={rec.recruiterName}>
                  {rec.recruiterName}
                </option>
              ))}
            </select>
          </div>

          <div className="submit-3d">
            <button type="submit" className="btn gradient-btn">
              <i className="bi bi-bar-chart-line"></i> Generate
            </button>
          </div>
        </div>
      </form>

      {/* EXPORT BUTTON (AFTER DATA LOAD) */}
      {misData && (
        <div style={{ margin: "15px 0", textAlign: "right" }}>
          <button className="btn gradient-btn" onClick={exportToExcel}>
            <i className="bi bi-file-earmark-excel"></i> Export Excel
          </button>
        </div>
      )}

      {/* ================= PERFORMANCE TABLE ================= */}
      {loading && <p>Loading Report...</p>}

      {misData && (
        <div className="mis-card">
        <div className="table-scroll-wrapper">
          <table className="resource-table recruiter-table">
            <thead>
              <tr>
                <th>Pipeline</th>
                <th>Shortlisted</th>
                <th>Offered</th>
                <th>Joined</th>
                <th>Serving NP</th>
                <th>Released</th>
                <th>Absconded</th>
                <th>Dropout</th>
                <th>Average Joined %</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>{misData.Pipeline ?? 0}</td>
                <td>{misData.Shortlisted ?? 0}</td>
                <td>{misData.Offered ?? 0}</td>
                <td>{misData.Joined ?? 0}</td>
                <td>{misData.ServingNP ?? 0}</td>
                <td>{misData.Released ?? 0}</td>
                <td>{misData.Absconded ?? 0}</td>
                <td>{misData.Dropout ?? 0}</td>
                <td>{misData.joiningConversionPct ?? 0}%</td>
              </tr>
            </tbody>
          </table>
        </div>
        </div>
      )}
    </div>
  );
};

export default RecruiterPerformance;
